import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs';
import { UrlBuilderService } from '../../services/url-builder.service';

@Injectable()
export class HomepageSelectionHttpService {

  private readonly API_URL: string;

  constructor(
    private readonly http: HttpClient,
    private readonly urlBuilder: UrlBuilderService) {
    this.API_URL = this.urlBuilder.getMojoApiUrl('homepageselection');
  }

  getHomepage(): Observable<string> {
    return this.urlBuilder.getMojoApiUrlObservable('homepageselection').pipe(switchMap(url =>
      this.http.get<string>(url).pipe(
        map(url => url || undefined)
      ))
    );
  }

  setHomepage(url: string): Observable<any> {
    return this.http.post(`${this.API_URL}/set?url=${url}`, { url: url });
  }
}
